export const usePages = () => {
    const pages = import.meta.glob("./pages/**/[1-9a-z]*.vue")

    return { pages }
}
